module.exports = __webpack_public_path__ + "img/img12.7188cfd6.png";